<!-- @format -->

<ng-container *transloco="let t">
  <h3>{{ t("ATTAINMENTS.ATTAINMENT_DETAILS.HEADINGS.CREDIT_TRANSFER_ACCEPTANCE_DETAILS") }}</h3>
  <dl>
    <div class="form-group-mimic" role="listitem">
      <dt>{{ t("ATTAINMENTS.ATTAINMENT_DETAILS.CREDIT_TRANSFER_ACCEPTANCE_DATE") }}</dt>
      <dd>{{ (creditTransferInfo?.creditTransferDate | localDateFormat) ?? "-" }}</dd>
    </div>
    <div class="form-group-mimic" role="listitem" [class.break-grid-row]="this.showInternationalInstitutionOrganisation">
      <dt>{{ t("ATTAINMENTS.ATTAINMENT_DETAILS.CREDIT_TRANSFER_ORIGINAL_EDUCATION_INSTITUTION") }}</dt>
      <dd>{{ (creditTransferInfo?.educationalInstitutionUrn | codeLocalizedName | async) ?? "-" }}</dd>
    </div>
    @if (this.showInternationalInstitutionOrganisation) {
      <div class="form-group-mimic" role="listitem">
        <dt>{{ t("ATTAINMENTS.ATTAINMENT_DETAILS.CREDIT_TRANSFER_INTERNATIONAL_INSTITUTION") }}</dt>
        @if (creditTransferInfo.internationalInstitutionUrn) {
          <dd>
            {{ creditTransferInfo.internationalInstitutionUrn | codeLocalizedName | async }}
          </dd>
        }
        @if (creditTransferInfo.organisation) {
          <dd>{{ creditTransferInfo.organisation }}</dd>
        }
      </div>
    }
  </dl>
</ng-container>
